import { render, staticRenderFns } from "./PurcharsePlan.vue?vue&type=template&id=de20135e&"
import script from "./PurcharsePlan.vue?vue&type=script&lang=js&"
export * from "./PurcharsePlan.vue?vue&type=script&lang=js&"
import style0 from "./PurcharsePlan.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports